/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Запись getSignedAssociatedAppsASIDAsync: ASID игрока в связанном FB-приложении и подпись Facebook.
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid
 */
export interface FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid {
    /**
     * FB App ID связанного приложения (getAppID()).
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid
     */
    AppId: string;
    /**
     * ASID игрока в связанном приложении (getASID()).
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid
     */
    Asid: string;
    /**
     * Подпись записи (getSignature()): signed request, подписанный секретом связанного приложения.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid
     */
    SignedRequest: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid(value: object): value is FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    if (!('Asid' in value) || value['Asid'] === undefined) return false;
    if (!('SignedRequest' in value) || value['SignedRequest'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid {
    if (json == null) {
        return json;
    }
    return {

        'AppId': json['AppId'],
        'Asid': json['Asid'],
        'SignedRequest': json['SignedRequest'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'AppId': value['AppId'],
        'Asid': value['Asid'],
        'SignedRequest': value['SignedRequest'],
    };
}
